// @flow
export { default } from './BrandHead';



// WEBPACK FOOTER //
// ./src/components/brand/BrandHead/index.js